import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import DAProtect from '@wix/da-ds/pkg/Icons/24x24/DAProtect';
import BetaBadge from '../../../BetaBadge';
import s from './DaProtectNotice.scss';
var DaProtectNotice = function () {
    var t = useTranslation().t;
    var onClick = useCallback(function (e) {
        window.location.assign('https://www.deviantartsupport.com/en/article/what-is-deviantart-protect');
        e.preventDefault();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(BetaBadge, { className: s['da-protect-newbadge'], variant: "small", badgeType: "new" }),
        React.createElement("div", { className: s['da-protect-heading'] },
            React.createElement(DAProtect, { className: s['da-protect-icon'] }),
            t('daProtect.submit.heading')),
        React.createElement("div", { className: s['da-protect-content'] },
            React.createElement(Trans, { i18nKey: "daProtect.submit.content" },
                "DeviantArt has your back...",
                React.createElement("br", null),
                "Now all new submissions enjoy 3 months protection against art theft on DeviantArt.",
                React.createElement("span", { className: s['fake-link'], onClick: onClick }, "Learn more")))));
};
DaProtectNotice.displayName = 'DaProtectNotice';
export default DaProtectNotice;
//# sourceMappingURL=DaProtectNotice.js.map